import addressApi from "api/landlord/address";

import { getErrorMessage } from "utils/error";
import { Button, ButtonSize, ButtonVariant, TextArea } from "shared/components";
import { StickerSquare } from "untitledui-js-base";
import { FC, useState } from "react";
import { useParams } from "react-router-dom";
import { ApplicationNote } from "./types";
import { Note } from "./Note";
import { toast } from "react-toastify";

type Props = {
  notes: ApplicationNote[];
  refetchNotes: () => void;
  closeNotesDrawer: () => void;
};

export const NotesList: FC<Props> = ({
  closeNotesDrawer,
  notes,
  refetchNotes
}) => {
  const [newNote, setNewNote] = useState<string>("");
  const { applicationId } = useParams();

  return (
    <div className="flex h-full flex-col">
      {!notes.length ? (
        <div className="mb-6 flex flex-auto flex-col items-center justify-center border-b border-alpha-40">
          <div className="mb-6 flex h-[64px] w-[64px] items-center justify-center rounded-full bg-alpha-40 p-5">
            <StickerSquare size="24" className="stroke-content-500" />
          </div>
          <p className="text-sm font-medium text-content-300">No notes yet</p>
        </div>
      ) : (
        <div className="mb-6 flex-1 overflow-auto border-b border-alpha-40">
          {notes.map((note) => {
            return (
              <Note
                note={note}
                key={note.id}
                applicationId={Number(applicationId)}
                refetchNotes={refetchNotes}
              />
            );
          })}
        </div>
      )}
      <div className="mx-6 mb-4">
        <TextArea
          id="note"
          placeholder="You can write a note here"
          onChange={(e) => setNewNote(e.target.value)}
          value={newNote}
        />
        <div className="my-4 flex justify-end gap-2">
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.BASE}
            onClick={closeNotesDrawer}
          >
            Cancel
          </Button>
          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.BASE}
            onClick={async () => {
              try {
                await addressApi.addApplicationNote(
                  Number(applicationId),
                  newNote
                );
                refetchNotes();
                setNewNote("");
              } catch (err) {
                toast.error(getErrorMessage(err));
              }
            }}
            disabled={!newNote}
          >
            Add Note
          </Button>
        </div>
      </div>
    </div>
  );
};
